export default __webpack_public_path__ + "static/media/linkedin.582b82ad.svg";